/// REFERENCE NOTES EDITOR INITIAL VALUES NORMALIZER FOR THIS ONE
import {
	NAME,
	SCOPE,
	GROUP_ROLE,
	REGION,
	EXTERNAL_USER, //TODO: to be implemented
	INTERNAL_USER,
	NOT_USING_CANVAS
} from '../utils/constants';

export default (defaultValues, initialValues, gaRoleTypes, components, GALinkStatus, optionNotApplicable) => {
	let normalizedInitialValues = {...defaultValues};
	if (!initialValues) return normalizedInitialValues;
	normalizedInitialValues[NAME] = initialValues.name;
	normalizedInitialValues[SCOPE] = initialValues.scopeId;
	normalizedInitialValues[GROUP_ROLE] = initialValues.role === gaRoleTypes.component
		? gaRoleTypes.component
		: gaRoleTypes.regional;
	normalizedInitialValues[INTERNAL_USER] = {
		label: '',
		value: initialValues.pointOfContact,
		allProps: {email: initialValues.pointOfContact, displayName: initialValues.pocText, gui: initialValues.pocGui}
	};
	normalizedInitialValues[REGION] = !!initialValues.gaParentComponentId
		? initialValues.gaParentComponentId
		: initialValues.role === gaRoleTypes.component
		? optionNotApplicable.id
		: null;
	normalizedInitialValues[NOT_USING_CANVAS] = initialValues.linkRequest === GALinkStatus.ComponentNotUsingCanvas ? true : false;
	return normalizedInitialValues;
};
